module.exports = __webpack_public_path__ + "img/fail.e405c75f.svg";